class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderUpsellContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getUpsellSectionsToRender().forEach((section => {
        if (document.getElementById(section.id) == null) return;
        if (section.id == 'cart-notification-product') {
          document.getElementById(section.id).innerHTML = '';
          parsedState.items.forEach((item) => {
            $(this.getSectionInnerHTML(parsedState.sections[section.id], `[id="cart-notification-product-${item.key}"]`)).appendTo($(`#${section.id}`));
          });
        } else {
          document.getElementById(section.id).innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          if (section.id == 'cart-notification-shipping') this.getShippingProgress();
        }
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getUpsellSectionsToRender() {
    return [
      {
        id: 'cart-notification-product'
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      },
      {
        id: 'cart-notification-shipping'
      }
    ];
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        if (document.getElementById(section.id) == null) return;
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        if (section.id == 'cart-notification-shipping') this.getShippingProgress();
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      },
      {
        id: 'cart-notification-shipping'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getShippingProgress() {
    const shipping = document.getElementById('cart-notification-shipping');
    const limit = shipping.querySelector('[data-shipping-limit]').dataset.shippingLimit;
    const total = shipping.querySelector('[data-shipping-total]').dataset.shippingTotal;
    const circumference = 28 * Math.PI;
    const percent = total / limit;
    const offset = circumference - (percent * circumference) / 2;
    shipping.querySelector('[data-shipping-progress]').style.strokeDashoffset = offset;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
